
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"80"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 4064","transform":"translate(-1512 -295)"}},[_c('circle',{attrs:{"data-name":"Ellipse 336","cx":"40","cy":"40","r":"40","transform":"translate(1512 295)","fill":"#24f7b8","opacity":".15"}}),_c('g',{attrs:{"data-name":"receipt","fill":"none","stroke":"#01b982","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3"}},[_c('path',{attrs:{"d":"M1544.271 347.32a2.616 2.616 0 014.265.24l1.544 2.16a2.6 2.6 0 004.479 0l1.544-2.16a2.616 2.616 0 014.265-.24c2.721 3.04 4.938 2.032 4.938-2.224v-18.031c.016-6.447-1.421-8.063-7.2-8.063h-11.557c-5.779 0-7.216 1.616-7.216 8.063v18.015c0 4.271 2.232 5.263 4.938 2.24z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M1544.326 326.667h16.008M1546.327 333.333h12.006"}})])])])
          )
        }
      }
    